import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useProcessApiClient } from '@/api/clients/useProcessApiClient.util.ts';
import {
  AttachProcessOfferToEmailResponseContentDto,
  ProcessOfferEmailVariantDto,
} from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = {
  emailId: string;
  processId: string;
  processOfferId: string;
  variant: ProcessOfferEmailVariantDto;
};

type Return = {
  attachOffer: (req: Req) => Promise<AttachProcessOfferToEmailResponseContentDto>;
  isAttachingOffer: boolean;
};

export const useAttachOfferToEmail = (): Return => {
  const { processOfferEmailAttachmentApi } = useProcessApiClient();
  const { userId } = useUserContext();

  const { isPending, mutateAsync } = useMutation<
    AttachProcessOfferToEmailResponseContentDto,
    AxiosError,
    Req
  >({
    meta: { disableSuccessAlert: true },
    mutationFn: async req => {
      const { data } = await processOfferEmailAttachmentApi.attachProcessOfferToEmail(
        userId,
        req.processId,
        req.processOfferId,
        req.emailId,
        { variant: req.variant },
      );
      return data;
    },
    mutationKey: [QueryKeyEnum.PROCESS.OFFER_ATTACH_TO_EMAIL],
  });

  return {
    attachOffer: mutateAsync,
    isAttachingOffer: isPending,
  };
};
